module.exports = __webpack_public_path__ + "static/media/nfti-utility-img.c99484b4.png";